import * as fromOstkProjectsActions from './projects/projects.actions';
import * as fromOstkInstancesActions from './instances/instances.actions';
import * as fromOstkMiscActions from './misc/misc.actions';
import * as fromOstkQuotasActions from './quotas/quotas.actions';
import * as fromOstkBillingActions from './billing/billing.actions';
import * as fromOstkImagesImgeActions from './images/imge/imge.actions';
import * as fromOstkImagesSnapActions from './images/snap/snap.actions';
import * as fromOstkVolumesVoluActions from './volumes/volu/volu.actions';
import * as fromOstkVolumesSnapActions from './volumes/snap/snap.actions';
import * as fromOstkNetworksNetwActions from './networks/netw/netw.actions';
import * as fromOstkSecurityGroupsActions from './security/sgrp/sgrp.actions';
import * as fromOstkKeyPairsActions from './security/keyp/keyp.actions';
import * as fromOstkFlavorsActions from './flavors/flavors.actions';
import * as fromOstkNetworksFipsActions from './networks/fips/fips.actions';

export
{
    getAllPlatforms, getPlatformsLoadingStatus, getPlatformsEmptyStatus, getPlatformsOupsStatus, getSelectedPlatform,
    getAllProjects, getProjectsLoadingStatus, getProjectsEmptyStatus, getProjectsOupsStatus, getSelectedProject,
    getCreateInstance,

    getAllQuotas, getQuotaByKey, getQuotasLoadingStatus, getQuotasLoadedStatus, getQuotasEmptyStatus, getQuotasOupsStatus, getQuotasIsDataValid,

    getAllSecurityGroups, getSecuritySgrpLoadingStatus, getSecuritySgrpEmptyStatus, getSecuritySgrpOupsStatus, getSecuritySgrpLoadedStatus, getPipelinedSecurityGroups,
    getSelectedSecurityGroup, getSecurityGroupById, getSelectedSecurityRules, getSecurityRulesLoadedStatus, getSecurityRuleById,
    getAllKeyPairs, getSecurityKeypLoadingStatus, getSecurityKeypEmptyStatus, getSecurityKeypOupsStatus, getSecurityKeypLoadedStatus, getPipelinedKeyPairs,

    getAllNetworksFips, getNetworksFipsLoadingStatus, getNetworksFipsLoadedStatus,
    getNetworksFipsEmptyStatus, getNetworksFipsOupsStatus,
    getQuickSearchedNetworksFips, getPipelinedNetworksFips,
    getFloatingIpById,

    getAllNetworksNetw, getNetworksNetwLoadingStatus, getNetworksNetwLoadedStatus,
    getNetworksNetwEmptyStatus, getNetworksNetwOupsStatus,
    getSelectedNetwork, getQuickSearchedNetworks, getPipelinedNetworks,
    getNetworkById, getPoolOptions
} from './ostk.reducer';

// Instances & Billing
export
{
    getAllInstances, getInstancesLoadingStatus, getInstancesLoadedStatus, getInstancesEmptyStatus, getInstancesOupsStatus, getInstancesIsDataValid,
    getPipelinedInstances,
    getInstanceFieldsFilter,
    countRunningInstances, countNonRunningInstances,
    getOperatingSystems, getInstancesAllVcpues, getInstancesAllRam,
    getSelectedInstance, getInstanceHistory
} from './ostk-instances.reducer';
export
{
    getAllBillingReferences, getBillingLoadingStatus, getBillingLoadedStatus, getBillingEmptyStatus, getBillingOupsStatus, getBillingIsDataValid, getBillingProject,
    getBilingReferenceFlavor, getBilingReferenceOs, getBilingReferenceFips, getBilingReferenceDisk, getBilingReferenceSnap,
} from './ostk-billing.reducer';

// Volumes
export
{
    getAllVolumesVolu, getVolumesVoluLoadingStatus, getVolumesVoluLoadedStatus, getVolumesVoluEmptyStatus, getVolumesVoluOupsStatus, getVolumesVoluIsDataValid,
    getPipelinedVolumesVolu,
    countVolumesVoluQuickFilterTrue, countVolumesVoluQuickFilterFalse,
    getVolumesVoluFieldsFilter, getVolumesVoluAvailable,
    getAllVolumesSnap, getVolumesSnapLoadingStatus, getVolumesSnapLoadedStatus, getVolumesSnapEmptyStatus, getVolumesSnapOupsStatus,
    getPipelinedVolumesSnap,
    getSelectedVolume
} from './ostk-volumes.reducer';

// Images
export
{
    getAllImages, getImagesLoadingStatus, getImagesLoadedStatus, getImagesEmptyStatus,
    getSnapshotsEmptyStatus, getImagesOupsStatus,
    getAllActiveImages, getDetailedImage, getAllImageSnapshots, getImageSnapshotsById,
    getPipelinedSnapshots,
    countImagesPublic, countImagesNotPublic,
    getImageFieldsFilter,
    getImagesAllStatuses, getImagesAllOperatingSystems,
    getPipelinedImages,
    getImagesIsDataValid
} from './ostk-images.reducer';

// Flavor
export
{
    getAllFlavors, getFlavorsLoadingStatus, getFlavorsLoadedStatus, getFlavorsEmptyStatus, getFlavorsOupsStatus, getFlavorsIsDataValid, getFlavorById,
} from './ostk-flavor.reducer';

// xref
export
{
    getOstkInstBySgrp,
    isOstkSgrpUsedByInst,
    getOstkInstByFixedFips,
    isOstkFixedFipsUsedByInst,
    getOstkInstByFloatingFips,
    isOstkFloatingFipsUsedByInst,
    getOstkInstWithoutFloatingFips,
    isOstkNetwUsedByInst,
    getOstkInstByNetw,
    isOstkNetwDeletable
} from './ostk-xref.reducer';

export { OstkStoreModule } from './ostk-store.module';

export
{
    fromOstkProjectsActions as OstkProjectsActions,
    fromOstkInstancesActions as OstkInstancesActions,
    fromOstkMiscActions as OstkMiscActions,
    fromOstkQuotasActions as OstkQuotaActions,
    fromOstkBillingActions as OstkBillingActions,
    fromOstkImagesImgeActions as OstkImagesImgeActions,
    fromOstkImagesSnapActions as OstkImagesSnapActions,
    fromOstkVolumesVoluActions as OstkVolumesVoluActions,
    fromOstkVolumesSnapActions as OstkVolumesSnapActions,
    fromOstkNetworksNetwActions as OstkNetworksNetwActions,
    fromOstkSecurityGroupsActions as OstkSecurityGroupsActions,
    fromOstkKeyPairsActions as OstkKeyPairsActions,
    fromOstkFlavorsActions as OstkFlavorsActions,
    fromOstkNetworksFipsActions as OstkNetworksFipsActions
};
